import { protectedApi } from './axios'

const cmrApi = {
  /**
   * @function addDocument
   * @param cmrId { number }
   * @param documents {{ name: string, file: string }[]} - file it's a base64 string
   * @return {Promise<AxiosResponse<void>>}
   */
  async addDocument(cmrId, documents) {
    return protectedApi.post('/cmr/add-document', { cmrId, documents })
  }
}

export default cmrApi
